/** A referential list: no tenant, no parameter. */
class FetchSubjectAbouts {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchSubjectAbouts;
